export * from './copyRacersColumns';
export * from './actions';
export * from './optionsActions';

export const LOAD_COPY_RACERS = 'LOAD_COPY_RACERS';
export const DELETE_TASK_COPY_RACERS = 'DELETE_TASK_COPY_RACERS';
export const ALL_DISTANCES_VALUE: number = -1;
